<template>
  <V3MapFilter :active="value != null" label="First K/D" @click="$emit('change', null)">
    <V3Button
      v-for="(option, key) of options"
      :key="key"
      :active="option.value === value"
      @click="$emit('change', option.value === value ? null : option.value)"
    >
      {{ option.text }}
    </V3Button>
  </V3MapFilter>
</template>

<script>
import { pxToolData } from '../../types.js'
import V3Button from '../v3dafi/V3Button.vue'
import V3MapFilter from '../v3dafi/V3MapFilter.vue'

export default {
  name: 'FKDFilter',
  components: {
    V3Button,
    V3MapFilter,
  },
  model: {
    event: 'change',
    prop: 'value',
  },
  props: {
    value: {
      default: null,
      type: String,
    },
    data: pxToolData(),
  },
  computed: {
    options() {
      return [
        { text: 'First Kill', value: 'fk' },
        { text: 'First Death', value: 'fd' },
      ]
    },
  },
}
</script>
